import {
  alpha,
  Box,
  DialogActions,
  DialogTitle,
  Icon,
  Link,
  Stack,
  StepLabel,
  styled,
  Typography,
} from '@nextiva/next-ui-components';

const CampaignTitle = styled(DialogTitle)`
  align-items: center;
  box-sizing: border-box;
  box-shadow: 0 0 8px 0
    ${({ theme }) => alpha(theme.palette.blueGrey[900], 0.08)};
  color: ${({ theme }) => theme.palette.common.white};
  display: flex;
  justify-content: space-between;
  min-height: 88px;
  padding: 24px 32px;
`;

const CampaignActions = styled(DialogActions)`
  color: ${({ theme }) => theme.palette.common.white};
  justify-content: space-between;
  min-height: 81px;
  padding: 16px 60px;
`;

const FaqTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.blueGrey[900]};
`;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.palette.blue[800]};
`;

const StyledStepLabel = styled(StepLabel)`
  & .MuiStepLabel-labelContainer {
    padding: 0 8px;
  }
  & .MuiStepLabel-label.Mui-active,
  & .MuiStepLabel-label.Mui-completed,
  & .MuiStepLabel-label.Mui-disabled {
    color: ${({ theme }) => theme.palette.blueGrey[900]};
    font-size: 14px;
    font-weight: 800;
    line-height: 20px;
    letter-spacing: 0.25px;
  }

  & .MuiStepIcon-root {
    height: 32px;
    width: 32px;
    color: ${({ theme }) => theme.palette.common.white};
    border: 2px solid ${({ theme }) => theme.palette.blueGrey.A400};
    border-radius: 50%;

    & .MuiStepIcon-text {
      fill: ${({ theme }) => theme.palette.blueGrey.A400};
      font-size: 14px;
      font-weight: 800;
      line-height: 20px;
      letter-spacing: 0.25px;
    }

    &.Mui-active {
      color: ${({ theme }) => theme.palette.blue[50]};
      border: 2px solid ${({ theme }) => theme.palette.blue[800]};
      & .MuiStepIcon-text {
        fill: ${({ theme }) => theme.palette.blue[800]};
      }
    }
  }
`;

const StyledIcon = styled(Icon)`
  background-color: ${({ theme }) => theme.palette.blue[50]};
  color: ${({ theme }) => theme.palette.blue[800]};
  border-radius: 16px;
`;

const BoxStep = styled(Box)`
  background: ${({ theme }) => theme.palette.grey[50]};
  height: 100%;
  width: 20.25rem;
  align-items: center;
  overflow: auto;
`;

const SavedCheckIcon = styled(Icon)`
  color: ${({ theme }) => theme.palette.blueGrey.A300};
  border-radius: 16px;
  font-size: 20px;
  &[data-status='saved'] {
    color: ${({ theme }) => theme.palette.teal.A300};
  }
`;

const SavedStack = styled(Stack)`
  background-color: ${({ theme }) => theme.palette.grey.A100};
  padding: 8px 12px;
  width: 94px;
  height: 40px;
  border-radius: 4px;
  &[data-status='saved'] {
    background-color: ${({ theme }) => theme.palette.green[50]};
  }
`;

const SavedTypography = styled(Typography)`
  line-height: 20px;
  color: ${({ theme }) => theme.palette.blueGrey.A600};
  &[data-status='saved'] {
    color: ${({ theme }) => theme.palette.blueGrey[900]};
  }
`;

export {
  CampaignTitle,
  CampaignActions,
  FaqTypography,
  BoxStep,
  SavedStack,
  SavedTypography,
  SavedCheckIcon,
  StyledLink,
  StyledStepLabel,
  StyledIcon,
};
